export const INIT_QUERY_PARAMS = {
  page: 1,
  paginate_by: 10,
  workspace_ids: [],
};
